import gql from 'graphql-tag';

export const WS_AVAILABILITY_UPDATE = gql`
  subscription($userIds: [String!]!) {
    availabilityUpdate (userIds: $userIds) {
      userId
      serviceIds
      userAvailability {
        status
        reason
      }
    }
  }
`;
